import { Routes } from '@angular/router';
import { BrowserMsalGuard } from '../core-services/authentication/browser-msal.guard';
import { MsalAuthGuard } from '../core-services/authentication/msal-auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'resources',
    loadComponent: () =>
      import('./features/dependent-features/home/home.component').then(
        (m) => m.HomeComponent,
      ),
    canActivate: [BrowserMsalGuard, MsalAuthGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/admin-features/admin/admin.component').then(
        (m) => m.AdminComponent,
      ),
    data: { breadcrumb: 'Admin', hideHeaderFooter: true },
    canActivate: [BrowserMsalGuard, MsalAuthGuard],
  },
  {
    path: 'uploadFile',
    loadComponent: () =>
      import(
        './features/admin-features/upload-file/upload-file.component'
      ).then((m) => m.UploadFileComponent),
    data: { breadcrumb: 'uploadFile' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'registerDependent',
    loadComponent: () =>
      import(
        './features/employee-features/register-dependents/register-dependents.component'
      ).then((m) => m.RegisterDependentsComponent),
    data: { breadcrumb: 'registerDependent' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent,
      ),
    data: { breadcrumb: '' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    data: { breadcrumb: 'dashboard' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'dependentRegisterList',
    loadComponent: () =>
      import(
        './features/employee-features/dependentregister-list/dependentregister-list.component'
      ).then((m) => m.DependentRegisterComponent),
    data: { breadcrumb: 'dependentRegisterList' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'registrationSuccess',
    loadComponent: () =>
      import(
        './features/employee-features/registration-success/registration-success.component'
      ).then((m) => m.RegistrationSuccessComponent),
    data: { breadcrumb: 'registrationSuccess' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'registrationCount',
    loadComponent: () =>
      import(
        './features/employee-features/registration-limit/registration-limit.component'
      ).then((m) => m.RegistrationLimitComponent),
    data: { breadcrumb: 'registrationCount' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: 'VideoUploadSuccess',
    loadComponent: () =>
      import(
        './features/admin-features/video-upload-success/video-upload-success.component'
      ).then((m) => m.VideoUploadSuccessComponent),
    data: { breadcrumb: 'VideoUploadSuccess' },
    canActivate: [MsalAuthGuard],
  },
  {
    path: '**',
    redirectTo: 'unauthorized'
  },
];
